import { calculateCMHCInsurance } from '@ratehub/mtg-common';


export default function getPaymentCalculatorCMHCInsurance({ formValues, paymentScenario }) {
    const { askingPrice, scenarios } = formValues;

    if (!askingPrice || scenarios[paymentScenario].downPayment?.dollars == null || !scenarios[paymentScenario].amortization) {
        return null;
    }

    return calculateCMHCInsurance(
        askingPrice,
        scenarios[paymentScenario].downPayment.dollars,
        scenarios[paymentScenario].amortization * 12,
    );
}